import { styled } from '@arpeggi/ui'

const Root = styled('div', {
  maxWidth: '600px',
  margin: 'auto',
  marginTop: '16px'
})

export const Discussions = {
  Root
}
